import { Box, BoxProps, Typography } from 'material-hu';
import { Icon, IconTypes } from 'src/types/icons';

type Props = {
  icon: Icon;
  sx?: BoxProps['sx'];
  size?: number;
};

const CustomIcon = ({ icon, sx, size = 50 }: Props) => (
  <Box sx={{ height: size, width: size, flexShrink: 0, ...sx }}>
    {icon?.type === IconTypes.IMAGE ? (
      <Box
        component="img"
        src={icon.value}
        alt="icon"
        sx={{ width: '100%', height: '100%' }}
      />
    ) : (
      <Typography
        sx={{ fontSize: size, lineHeight: `${size}px`, color: 'initial' }}
      >
        {icon.value}
      </Typography>
    )}
  </Box>
);

export default CustomIcon;
